import http from './http';

export const updatePortfolio = async (customerId: string, type: string, data: any) => {
  return await http.put(`/portfolio/${customerId}/${type}`, data);
};

export const getPortfolio = async (customerId: string, type: string) => {
  return await http.get(`/portfolio/${customerId}/${type}`);
};
